const SessionToken = ({ referenceKey = '', secret = '' } = {}) => ({
  referenceKey: String(referenceKey),
  secret: String(secret),
});

const StartPaymentMethodSession = ({ sessionToken = {}, businessUnit = '', zuoraUserToken = '' } = {}) => ({
  sessionToken: SessionToken(sessionToken),
  businessUnit: String(businessUnit),
  zuoraUserToken: String(zuoraUserToken),
});

export default StartPaymentMethodSession;

export type StartPaymentMethodSessionProps = ReturnType<typeof StartPaymentMethodSession>;
